import React from "react";
import { rng, PublicSurveyReportLink } from '../../../amorg-common';
import { segmentListsOfListsMatch } from '../../../amorg-common';
import { getSurveyReportLinks, createSurveyReportLink, deleteSurveyReportLink } from "../../../api/surveyClientApi";
import { LinkPanel, LinkPanelStatus } from '../../../designSystem/compositeComponents/LinkPanel';
import { SurveySegment } from '../../../amorg-common';
import { Label } from "../../../designSystem/Label";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";


type SurveyReportLinkPanelProps = { siteId: string, surveyId: string, segmentFilter: SurveySegment[][] }
type SurveyReportLinkPanelState = {
    links: PublicSurveyReportLink[],
    loading: boolean
}
export function SurveyReportLinkPanel(props: SurveyReportLinkPanelProps): JSX.Element {
    const [state, setState] = React.useState<SurveyReportLinkPanelState>({ links: [], loading: true });

    // Only run this once - requires refreshing when the component itself updates data
    React.useEffect(() => {
        async function getData() {
            const links = await getSurveyReportLinks(props.surveyId);
            setState({ links, loading: false });
        }
        getData();
    }, [props.surveyId])

    async function handleCreateLink() {
        setState({ ...state, loading: true });
        const result = await createSurveyReportLink(props.surveyId, rng.getRandomId(), props.segmentFilter);
        if (result.isSuccess) {
            const links = await getSurveyReportLinks(props.surveyId);
            setState({ links, loading: false });
        }
        else
            setState({ ...state, loading: false });
    }

    async function handleDeleteLink() {
        setState({ ...state, loading: true });
        const result = await deleteSurveyReportLink(matchingLink.id);
        if (result.isSuccess) {
            const links = await getSurveyReportLinks(props.surveyId);
            setState({ links, loading: false });
        }
        else
            setState({ ...state, loading: false });
    }

    const matchingLink = state.links.find(l => {
        return segmentListsOfListsMatch(l.configuration.segmentFilter, props.segmentFilter);
    });

    const linkUrl = matchingLink
        ? `${window.location.protocol}//${window.location.host}/surveys/publicreport/${matchingLink.id}@${props.siteId}`
        : '';

    let panelStatus:LinkPanelStatus = {value: "loading"};
    if(state.loading)
        panelStatus = {value: "loading"};
    else if(matchingLink !== undefined)
        panelStatus = {value:"has-link", url:linkUrl};
    else
        panelStatus = {value:'no-link', noLinkText:'Rapporten er ikke delt'}

    return (
        <Flex flexDirection={"column"} gap={4}>
            <Label formIndent>{matchingLink!==undefined ? 'Rapporten er delt' : 'Rapporten er ikke delt'}</Label>
            <LinkPanel link={panelStatus}
                onCreateLink={handleCreateLink}
                onDeleteLink={handleDeleteLink}
                />
        </Flex>
    );
}